import { exists as i } from "../runtime.js";
const o = {
  ParentCid: "PARENT_CID",
  HouseRegistration: "HOUSE_REGISTRATION",
  ParentSign: "PARENT_SIGN"
};
function c(e) {
  let t = !0;
  return t = t && "recordType" in e, t = t && "documentData" in e, t;
}
function u(e) {
  return r(e);
}
function r(e, t) {
  return e == null ? e : {
    recordType: e.recordType,
    documentData: e.documentData,
    documentMimeType: i(e, "documentMimeType") ? e.documentMimeType : void 0,
    expiryDate: i(e, "expiryDate") ? new Date(e.expiryDate) : void 0,
    issueDate: i(e, "issueDate") ? new Date(e.issueDate) : void 0
  };
}
function d(e) {
  if (e !== void 0)
    return e === null ? null : {
      recordType: e.recordType,
      documentData: e.documentData,
      documentMimeType: e.documentMimeType,
      expiryDate: e.expiryDate === void 0 ? void 0 : e.expiryDate.toISOString(),
      issueDate: e.issueDate === void 0 ? void 0 : e.issueDate.toISOString()
    };
}
export {
  u as MinorDocumentFromJSON,
  r as MinorDocumentFromJSONTyped,
  o as MinorDocumentRecordTypeEnum,
  d as MinorDocumentToJSON,
  c as instanceOfMinorDocument
};
//# sourceMappingURL=MinorDocument.js.map
